<ng-container *ngIf="(content$ | async) as content; else no_content">
  <gems-wrapper class="f-1 flex-column"
    [siteMap]="content.siteMap"
    [unreadMessageCount]="content.unreadCount"
    [isAdminViewMode]="true"
    [banners]="content.banners"
  >
    <app-session-expiration></app-session-expiration>
    <div class="container-gray mt-16">
      <router-outlet></router-outlet>
    </div>
  </gems-wrapper>

  <app-keep-alive [keepAliveUrl]="content.siteMap.keepAliveUrl"></app-keep-alive>
</ng-container>

<ng-template #no_content>
  <gems-spinner></gems-spinner>
</ng-template>

